import template from './notification-types.html';
import './notification-types.css';

class NotificationTypesVM
{
	constructor (page)
	{
		this.page = page;
		this.notification_types = ko.observableArray([]);
		this.notification_groups = ko.observableArray([]);
		this.channels = ko.observableArray([]);
		this.loading = ko.observable(true);
	}

	async btnAddType_click ()
	{
		const result = await Grape.dialog.open('EditNotificationType', {
			channels: this.channels()
		});
		if (result)
			await this.page.updateData();
	}

	async btnEditType_click (notification_type)
	{
		const result = await Grape.dialog.open('EditNotificationType', {
			notification_type: notification_type,
			channels: this.channels()
		});
		if (result)
			await this.page.updateData();
	}
}

class NotificationTypesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new NotificationTypesVM(this);
	}

	async init ()
	{
		await this.updateData();
	}

	async updateData ()
	{
		this.viewModel.loading(true);

		try
		{
			const [types_res, channels_res] = await Promise.all([
				Grape.fetches.getJSON('/api/record', {
					schema: 'notifications',
					table: 'v_notification_type'
				}),
				Grape.fetches.getJSON('/api/record', {
					schema: 'notifications',
					table: 'v_notification_channel'
				})
			]);

			const types = types_res.records || [];
			this.viewModel.channels(channels_res.records || []);

			const groups_map = {};
			for (const t of types)
			{
				const group = t.notification_group || 'Ungrouped';
				if (!groups_map[group])
					groups_map[group] = [];
				groups_map[group].push(t);
			}

			const groups = [];
			for (const group_name of Object.keys(groups_map).sort())
				groups.push({ name: group_name, types: groups_map[group_name] });

			this.viewModel.notification_groups(groups);
			this.viewModel.notification_types(types);
		}
		catch (err)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: err.message });
		}

		this.viewModel.loading(false);
	}
}

export default {
	route: '[/]ui/admin/notification-types',
	page_class: NotificationTypesPage,
	template: template
}
